import KeenSlider from 'keen-slider'
import { keyboard, arrows } from './slider-plugins'

const initSlider = () => {
  const sliders = document.querySelectorAll('.js-slider')

  if (!sliders?.length) return

  sliders.forEach(
    (slider) =>
      new KeenSlider(
        slider,
        {
          loop: false,
          drag: true,
          // slides: {
          //   perView: 2.5,
          // },
          breakpoints: {
            '(min-width: 0)': {
              slides: {
                perView: slider.children.length !== 1 ? 1.05 : 1,
              },
            },

            '(min-width: 730px)': {
              slides: {
                perView: slider.children.length >= 2 ? 1.5 : 2,
              },
            },

            '(min-width: 960px)': {
              slides: {
                perView: slider.children.length > 2 ? 2.5 : 2,
              },
            },
          },
        },
        [keyboard, arrows],
      ),
  )
}

initSlider()
